var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentRating16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_100)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.975,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81034 -0.258621C10.4311 -0.258621 19.0517 -0.258621 27.6724 -0.258621C28.3422 0.252604 29.0319 0.769846 29.7414 1.2931C29.7414 10.2586 29.7414 19.2242 29.7414 28.1897C29.0517 28.5345 28.5345 29.0517 28.1897 29.7414C19.2242 29.7414 10.2586 29.7414 1.2931 29.7414C0.948274 29.0517 0.431034 28.5345 -0.258621 28.1897C-0.258621 19.3966 -0.258621 10.6034 -0.258621 1.81034C0.25862 0.948274 0.948274 0.25862 1.81034 -0.258621Z",
    fill: "#EA9C31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1207 3.87931C11.1207 11.2931 11.1207 18.7069 11.1207 26.1207C9.91381 26.1207 8.70688 26.1207 7.5 26.1207C7.66971 20.1661 7.49731 14.304 6.98276 8.53449C4.12774 10.9428 2.83463 10.2531 3.10345 6.46552C4.52494 5.45281 5.99043 4.50453 7.5 3.62069C8.81302 3.20907 10.0199 3.29528 11.1207 3.87931Z",
    fill: "#FEFDFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4655 3.36207C22.6724 3.36207 23.8793 3.36207 25.0862 3.36207C25.0862 4.74138 25.0862 6.12067 25.0862 7.5C21.2794 7.26181 19.1242 8.98593 18.6207 12.6724C23.8363 10.5042 26.5087 12.3145 26.6379 18.1034C26.7187 24.7588 23.6153 27.345 17.3276 25.8621C15.6443 24.6507 14.696 23.0128 14.4828 20.9483C12.5422 13.2104 14.8698 7.3484 21.4655 3.36207Z",
    fill: "#FEFBF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1207 3.87931C11.6359 11.3744 11.8083 18.9606 11.6379 26.6379C10.0862 26.6379 8.53448 26.6379 6.98276 26.6379C6.98276 20.6034 6.98276 14.569 6.98276 8.53448C7.49731 14.304 7.66971 20.1661 7.5 26.1207C8.70688 26.1207 9.91381 26.1207 11.1207 26.1207C11.1207 18.7069 11.1207 11.2931 11.1207 3.87931Z",
    fill: "#F7D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3966 15.2586C21.6478 15.1664 22.6823 16.2871 22.5 18.6207C22.547 20.4756 21.8573 21.9412 20.431 23.0172C19.5535 22.5706 18.9501 21.8809 18.6207 20.9483C18.1102 18.8923 18.3688 16.9958 19.3966 15.2586Z",
    fill: "#EA9D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentRating16);
export default __webpack_public_path__ + "static/media/ic_content_rating_16.10d9c9244ca2a0db3478fc1d9e0afe6f.svg";
export { ForwardRef as ReactComponent };